import Button from "components/global/Button";
import Spacer from "components/global/Spacer";
import styled from "styled-components";
import {
  ConnectChecklist,
  ConnectFacebookInfo,
  ConnectGuide,
  ConnectInstagramToFacebook,
  ConnectTiktokInfo,
  ConnectToIgPrompt,
  InstagramAccountConvertInfo,
  RequestCall,
} from "views/socialMedia/ChannelInfoModals";
import { socialIcons } from "views/socialMedia/ManageChannels";
import useManageChannels from "hooks/useManageChannels";
import { Route, withRouter, useRouteMatch } from "react-router-dom";
import SelectAccountModal from "views/socialMedia/SelectAccountModal";
import { connect } from "react-redux";
import { useLocation, useHistory } from "react-router-dom";
import {
  aIAxiosInstance,
  getAccount,
  getTooltip,
  saveAiPostIdea,
  updateTooltip,
} from "api";
import { useEffect, useState } from "react";
import { showAlert, truncateText } from "utils/utils";
import Loader from "components/global/Loader";
import userIcon from "assets/icons/userIconWhite.svg";
import ConnectionFailureModal from "views/socialMedia/ConnectionFailureModal";
import { Redirect } from "react-router-dom";
import useIsMobile from "hooks/useIsMobile";
import { borderColor } from "views/postPlanner/posts/SelectSocialMedia";
import ConfirmModal from "components/global/ConfirmModal";
import PlusIcon from "icons/PlusIcon";
import { store } from "api/store";
import { SET_SHOW_APP_MODAL } from "api/actions/types";

const Wrapper = styled.div`
  position: relative;

  .header {
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    margin-bottom: 0.8rem;
  }

  .description {
    font-size: 14px;
    font-style: normal;
    font-weight: 450;
    line-height: 20px;
    color: var(--body_text);
  }

  .connectionBox {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
  }

  .footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 24px;
    border-radius: 0 0 8px 8px;
    position: relative;
  }

  @media screen and (max-width: 768px) {
    width: 100%;
    margin-bottom: 20px;
    padding: 8px;

    .connectionBox {
      grid-template-columns: 1fr;
    }

    .footer {
      position: fixed;
      bottom: 0;
      padding: 24px 24px;
      left: 0;
      background-color: var(--white);
    }
  }
`;

const ConnectItem = styled.div`
  border: 1px solid var(--grey_10);
  padding: 8px;
  height: 115px;
  border-radius: 8px;
  font-size: 14px;
  font-style: normal;
  font-weight: 450;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  &.connected {
    background-color: #fafafa;
  }

  &.disabled {
    pointer-events: none;
  }

  .social {
    display: flex;
    align-items: center;
    gap: 12px;

    .icon {
      height: 24px;
      width: 34px;
    }

    .platformImg {
      width: 16px;
      height: 16px;
      right: 0;
    }

    .socialName {
      max-width: 90%;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      letter-spacing: 0em;
    }
  }

  .username {
    text-align: center;
  }

  .username,
  .platform {
    max-width: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    letter-spacing: 0em;
    padding: 2px 0;
  }

  .connect-btn {
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    border: 0;
    color: var(--secondary);
    width: 100%;
    background-color: #ffffff;

    &.removeBtn {
      color: red;
      background-color: #fafafa;

      &:hover {
        color: red;
      }
    }

    &:hover {
      background-color: #fafafa;
      color: var(--secondary);
    }
  }

  @media screen and (max-width: 768px) {
    display: grid;
    grid-template-columns: 1fr 4fr 1fr;
    width: 100%;
    height: 100%;

    .username {
      text-align: left;
    }

    .footer {
      position: fixed;
      bottom: 0;
    }
  }
`;

const SelectedStyle = styled.div`
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: ${(props) => `2px solid ${props.color}`};
  border-radius: 50%;

  img {
    width: 28.8px;
    height: 28.8px;
  }
`;

const ConnectSocials = ({
  brands,
  onboarding_state,
  active_account,
  user_token,
  user,
}) => {
  const history = useHistory();
  const { search } = useLocation();
  const isSuccess = new URLSearchParams(search).get("connectionSuccess");
  const successMsg = new URLSearchParams(search).get("success");
  const isMobile = useIsMobile(768);
  const targetBrand = brands[0];
  const { path } = useRouteMatch();
  const {
    loadSocials,
    platformList,
    loading,
    connecting,
    socials,
    handleConnectPlatform,
    handleRemoveChannel,
    removeSocial,
  } = useManageChannels(targetBrand?.id);

  const connectableChannels = active_account?.privilege
    ?.connectable_channels || ["facebook", "instagram", "linkedin"];

  const [isCompleting, setIsCompleting] = useState(false);

  const handleContinue = async () => {
    // Complete onboarding and redirect to dashboard
    setIsCompleting(true);
    try {
      await updateTooltip({
        ...onboarding_state,
        onboarding_completed: true,
        completed_brand_info: true,
      });
      await getAccount();
      await getTooltip();

      showAlert({
        msg: "Onboarding completed successfully!",
        type: "success",
      });

      history.replace("/dashboard/home");
    } catch (error) {
      showAlert({
        msg: "An error occurred while completing onboarding",
        type: "danger",
      });
      setIsCompleting(false);
    }
  };

  const handleSaveIdeas = async (ideas) => {
    const postIdeas = ideas?.map((idea) => {
      return {
        topic: idea.topic_idea,
        idea: idea.post_idea,
      };
    });
    const data = {
      content: postIdeas,
    };

    try {
      await saveAiPostIdea(data);
    } catch (err) {
      console.log("err", err);
    }
  };

  const handleGeneratePostIdeas = async () => {
    const task = "generate_new_ideas_and_caption";
    const data = {
      brand_name: brands[0]?.name,
      brand_category: brands[0].category,
    };

    try {
      const res = await aIAxiosInstance.post(`${task}`, data, {
        headers: {
          "X-USER": user_token,
          "X-ACC-ID": active_account?.id,
        },
      });
      const postIdeas = res.data.post_ideas;

      if (postIdeas) {
        handleSaveIdeas(postIdeas);
      }
    } catch (err) {
      console.log("err", err);
    }
  };

  useEffect(() => {
    if (isSuccess !== null && successMsg !== null) {
      if (isSuccess === "true") {
        showAlert({
          msg: "Connection successful",
          type: "success",
        });
      } else if (successMsg) {
        showAlert({
          msg: successMsg,
          type: "success",
        });
      }
    }
  }, [isSuccess, successMsg]);

  useEffect(() => {
    handleGeneratePostIdeas();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (onboarding_state.onboarding_completed) {
      store.dispatch({
        type: SET_SHOW_APP_MODAL,
        payload: true,
      });
    }
  }, [onboarding_state]);

  // Redirect to select plan if user hasn't selected a plan yet
  // if (user?.free_trial === "unused") {
  //   return <Redirect to="/onboarding/select-plan" />;
  // }

  if (brands.length === 0) {
    return <Redirect to="/onboarding/create-brand" />;
  }

  return (
    <>
      <ConfirmModal
        id="confirmPlatformRemoval"
        action="remove this social media channel"
        description={`Removing this channel means you won't be able to post to it from PostPaddy.`}
        actionText="Remove"
        callback={() => removeSocial()}
      />

      {/* Connect guide request for instagram connection */}
      <ConnectGuide disabled={connecting} />

      {/* Connect guide check list */}
      <ConnectChecklist
        disabled={connecting}
        handleConnection={() => handleConnectPlatform("instagram")}
      />

      {/* Request call */}
      <RequestCall />

      {/* Instagram Personal to business account guide */}
      <InstagramAccountConvertInfo
        disabled={connecting}
        handleConnection={() => handleConnectPlatform("instagram")}
      />

      {/* Authenticate Instagram with facebook guide */}
      <ConnectInstagramToFacebook
        disabled={connecting}
        handleConnection={() => handleConnectPlatform("instagram")}
      />

      {/* connect facebook info */}
      <ConnectFacebookInfo
        disabled={connecting}
        handleConnection={() => handleConnectPlatform("facebook")}
      />

      {/* tiktok connect info */}
      <ConnectTiktokInfo
        disabled={connecting}
        handleConnection={() => handleConnectPlatform("tiktok")}
      />

      <ConnectToIgPrompt
        handleConnection={() => handleConnectPlatform("instagram", true)}
        disabled={connecting}
      />

      <Wrapper>
        <h2 className="body-1 textCenter">
          Connect your social media profiles
        </h2>
        {/* <p className="description textCenter">
          Connect your Facebook, Instagram, X(Twitter), TikTok,
          <br /> LinkedIn, and YouTube accounts.
        </p> */}
        <Spacer y={2.8} />

        {loading ? (
          <Loader />
        ) : (
          <div className="connectionBox">
            {socials?.map((channel, idx) => {
              const { platform, page } = channel;

              return (
                <ConnectItem className="connected">
                  <div className="social">
                    <SelectedStyle
                      className="circle"
                      color={borderColor[platform]}
                    >
                      <img
                        src={page?.photo || userIcon}
                        alt="avi"
                        className="circle"
                      />
                    </SelectedStyle>
                  </div>
                  <div className="socialName flexCol">
                    <p className="connected l3 bold username">
                      {page?.name ?? page?.username}
                    </p>
                    {platform === "linkedin" && (
                      <p className="colorBodyText l3 platform">
                        LinkedIn{" "}
                        {page?.category === "personal" ? "profile" : "page"}{" "}
                        connected
                      </p>
                    )}
                    {platform === "facebook" && (
                      <p className="colorBodyText l3 platform">
                        Facebook page connected
                      </p>
                    )}
                    {platform === "instagram" && (
                      <p className="colorBodyText l3 platform">
                        Instagram Business connected
                      </p>
                    )}
                    {platform === "twitter" && (
                      <p className="colorBodyText l3 platform">
                        Twitter profile connected
                      </p>
                    )}
                    {platform === "youtube" && (
                      <p className="colorBodyText l3 platform">
                        YouTube channel connected
                      </p>
                    )}
                    {platform === "tiktok" && (
                      <p className="colorBodyText l3 platform">
                        TikTok Business connected
                      </p>
                    )}
                    {platform === "pinterest" && (
                      <p className="colorBodyText l3 platform">
                        Pinterest Profile connected
                      </p>
                    )}
                    {platform === "meta_threads" && (
                      <p className="colorBodyText l3 platform">
                        Threads Profile connected
                      </p>
                    )}
                  </div>
                  <button
                    className="connect-btn removeBtn"
                    onClick={() => handleRemoveChannel(platform)}
                  >
                    Remove
                  </button>
                </ConnectItem>
              );
            })}
            {!platformList?.includes("facebook") && (
              <ConnectItem
                onClick={(e) => {
                  e.stopPropagation();
                  document
                    .querySelector(".connectFacebookInfo")
                    .classList.add("show");
                }}
                className={connecting ? "disabled" : ""}
              >
                <div className="social">
                  <img
                    src={socialIcons.default["facebook"]}
                    className="icon"
                    alt="icon"
                  />
                </div>
                <div className="socialName">Facebook page</div>

                <Button
                  className="connect-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    document
                      .querySelector(".connectFacebookInfo")
                      .classList.add("show");
                  }}
                  text="Connect"
                  iconComponent={<PlusIcon color="var(--secondary)" />}
                  height="36px"
                  disabled={
                    connecting ||
                    !(
                      active_account?.privilege?.connectable_channels ?? []
                    ).includes("facebook")
                  }
                  invertOnHover
                />
              </ConnectItem>
            )}

            {!platformList?.includes("instagram") && (
              <ConnectItem
                onClick={(e) => {
                  e.stopPropagation();
                  document
                    .querySelector(".ConnectToIgPrompt")
                    .classList.add("show");
                }}
                className={connecting ? "disabled" : ""}
              >
                <div className="social">
                  <img
                    src={socialIcons.default["instagram"]}
                    className="icon"
                    alt="icon"
                  />
                </div>
                <div className="socialName">Instagram Business</div>

                <Button
                  className="connect-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    document
                      .querySelector(".ConnectToIgPrompt")
                      .classList.add("show");
                  }}
                  text="Connect"
                  iconComponent={<PlusIcon color="var(--secondary)" />}
                  height="36px"
                  disabled={
                    connecting ||
                    !(
                      active_account?.privilege?.connectable_channels ?? []
                    ).includes("instagram")
                  }
                  invertOnHover
                />
              </ConnectItem>
            )}

            {!platformList?.includes("linkedin") && (
              <ConnectItem
                onClick={(e) => {
                  e.stopPropagation();
                  handleConnectPlatform("linkedin");
                }}
                className={connecting ? "disabled" : ""}
              >
                <div className="social">
                  <img
                    src={socialIcons.default["linkedin"]}
                    className="icon"
                    alt="icon"
                  />
                </div>
                <div className="socialName">
                  {isMobile
                    ? truncateText("LinkedIn Profile or Page", 10)
                    : "LinkedIn Profile or Page"}
                </div>

                <Button
                  className="connect-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleConnectPlatform("linkedin");
                  }}
                  text="Connect"
                  iconComponent={<PlusIcon color="var(--secondary)" />}
                  height="36px"
                  disabled={
                    connecting ||
                    !(
                      active_account?.privilege?.connectable_channels ?? []
                    ).includes("linkedin")
                  }
                  invertOnHover
                />
              </ConnectItem>
            )}

            {!platformList?.includes("twitter") && (
              <ConnectItem
                onClick={(e) => {
                  e.stopPropagation();
                  handleConnectPlatform("twitter");
                }}
                className={connecting ? "disabled" : ""}
              >
                <div className="social">
                  <img
                    src={socialIcons.default["twitter"]}
                    className="icon"
                    alt="icon"
                  />
                </div>
                <div className="socialName">Twitter</div>

                <Button
                  className="connect-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleConnectPlatform("twitter");
                  }}
                  text="Connect"
                  iconComponent={<PlusIcon color="var(--secondary)" />}
                  height="36px"
                  disabled={
                    connecting ||
                    !(
                      active_account?.privilege?.connectable_channels ?? []
                    ).includes("twitter")
                  }
                  invertOnHover
                />
              </ConnectItem>
            )}

            {!platformList?.includes("youtube") && (
              <ConnectItem
                onClick={(e) => {
                  e.stopPropagation();
                  handleConnectPlatform("youtube");
                }}
                className={connecting ? "disabled" : ""}
              >
                <div className="social">
                  <img
                    src={socialIcons.default["youtube"]}
                    className="icon"
                    alt="icon"
                  />
                </div>
                <div className="socialName">YouTube</div>

                <Button
                  className="connect-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleConnectPlatform("youtube");
                  }}
                  text="Connect"
                  iconComponent={<PlusIcon color="var(--secondary)" />}
                  height="36px"
                  disabled={
                    connecting ||
                    !(
                      active_account?.privilege?.connectable_channels ?? []
                    ).includes("youtube")
                  }
                  invertOnHover
                />
              </ConnectItem>
            )}

            {!platformList?.includes("tiktok") && (
              <ConnectItem
                onClick={() =>
                  document
                    .querySelector(".connectTiktokInfo")
                    .classList.add("show")
                }
                className={connecting ? "disabled" : ""}
              >
                <div className="social">
                  <img
                    src={socialIcons.default["tiktok"]}
                    className="icon"
                    alt="icon"
                  />
                </div>
                <div className="socialName">TikTok Business</div>

                <Button
                  className="connect-btn"
                  onClick={() =>
                    document
                      .querySelector(".connectTiktokInfo")
                      .classList.add("show")
                  }
                  text="Connect"
                  iconComponent={<PlusIcon color="var(--secondary)" />}
                  height="36px"
                  disabled={
                    connecting ||
                    !(
                      active_account?.privilege?.connectable_channels ?? []
                    ).includes("tiktok")
                  }
                  invertOnHover
                />
              </ConnectItem>
            )}

            {!platformList?.includes("pinterest") && (
              <ConnectItem
                onClick={(e) => {
                  e.stopPropagation();
                  handleConnectPlatform("pinterest");
                }}
                className={connecting ? "disabled" : ""}
              >
                <div className="social">
                  <img
                    src={socialIcons.default["pinterest"]}
                    className="icon"
                    alt="icon"
                  />
                </div>
                <div className="socialName">
                  {isMobile
                    ? truncateText("Pinterest Profile or Page", 10)
                    : "Pinterest Profile or Page"}
                </div>

                <Button
                  className="connect-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleConnectPlatform("pinterest");
                  }}
                  text="Connect"
                  iconComponent={<PlusIcon color="var(--secondary)" />}
                  height="36px"
                  disabled={
                    connecting ||
                    !(
                      active_account?.privilege?.connectable_channels ?? []
                    ).includes("pinterest")
                  }
                  invertOnHover
                />
              </ConnectItem>
            )}

            {!platformList?.includes("meta_threads") && (
              <ConnectItem
                onClick={(e) => {
                  e.stopPropagation();
                  handleConnectPlatform("meta-threads");
                }}
                className={connecting ? "disabled" : ""}
              >
                <div className="social">
                  <img
                    src={socialIcons.default["meta_threads"]}
                    className="icon"
                    alt="icon"
                  />
                </div>
                <div className="socialName">Threads Profile</div>

                <Button
                  className="connect-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleConnectPlatform("meta-thread");
                  }}
                  text="Connect"
                  iconComponent={<PlusIcon color="var(--secondary)" />}
                  height="36px"
                  disabled={
                    connecting ||
                    !(
                      active_account?.privilege?.connectable_channels ?? []
                    ).includes("meta_threads")
                  }
                  invertOnHover
                />
              </ConnectItem>
            )}
          </div>
        )}

        <Spacer y={2.4} />
        <p className="fullWidth textCenter colorGrey4">
          Having problems? Click{" "}
          <span
            className="colorSecondary cursorPointer contactSupport"
          >
            here
          </span>{" "}
          to contact support.
        </p>

        {!loading && (
          <div className="footer connectModal fillAvailable">
            <Button
              text={"Continue"}
              bg="var(--secondary)"
              width="100%"
              className="spanFull"
              onClick={handleContinue}
              loading={isCompleting}
              disabled={isCompleting}
            />
          </div>
        )}
      </Wrapper>

      {/* render connection failure modal when platform connection fails */}
      <ConnectionFailureModal path="/onboarding/connect-channel" />

      {/* Select account/page modal */}
      <Route
        exact
        path={`${path}/select-account`}
        component={() => (
          <SelectAccountModal
            brand={targetBrand}
            path={path}
            loadSocials={loadSocials}
          />
        )}
      />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    brands: state.brands,
    onboarding_state: state.guided_tours,
    active_account: state.active_account,
    user_token: state.user_token,
    user: state.user,
  };
};

export default withRouter(connect(mapStateToProps)(ConnectSocials));
